import React, { useEffect, useState }from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt} from '@fortawesome/free-solid-svg-icons'
import { faInfoCircle} from '@fortawesome/free-solid-svg-icons'
import { faEnvelope} from '@fortawesome/free-solid-svg-icons'
import { faPhone} from '@fortawesome/free-solid-svg-icons'
import { faGlobe} from '@fortawesome/free-solid-svg-icons'
import { faBriefcase} from '@fortawesome/free-solid-svg-icons'
//import githubIcon from '../Images/gitgub.svg'
import coverPhotoContImage from '../Images/default-cover.gif'
import profilePictureContImage from '../Images/defprofile.png'

// firebase
import {db} from '../firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { collection, query, getDocs, where } from "firebase/firestore";

//routers
import {useNavigate } from "react-router-dom";

function ProfileComp() {
  //states
  const [loggedInUser, setLoggedInUser] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [employeePosition, setEmployeePosition] = useState("");
  const [employeeDepartment, setEmployeeDepartment] = useState("");
  const [userNationality, setNationality] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [userPhone, setUserPhone] = useState("");
  const [userWebsite, setUserWebsite] = useState("");
  const [userAbout, setUserAbout] = useState("");
  const [userExpectation, setUserExpectation] = useState("");
  const [userCourse, setUserCourse] = useState("");
  const [userSessionTime, setUserSessionTime] = useState("");
  const [userClassType, setUserClassType] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  //profile pic & cover
  const [userProfilePicture, setProfilePicture] = useState(profilePictureContImage);
  const [userCoverPicture, setCoverPicture] = useState(coverPhotoContImage);

  const auth = getAuth();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
      //if user is logged in 
      const uid = user.uid;

      const q = query(collection(db, "Employees"), where("docId", "==", uid));
      getDocs(q).then((QuerySnapshot)=>{
          setIsLoading(true);
          QuerySnapshot.forEach((doc)=>{
          const username = doc.data().employeeName;
          const employeeId = doc.data().employeeId || doc.data().employeeID || doc.data().staffId || doc.data().staffID;
          const employeePosition = doc.data().position;
          const employeeDepartment = doc.data().department || doc.data().team || doc.data().role;
          const nationality = doc.data().country;
          const userEmail = doc.data().employeeEmail;
          const phoneNumber = doc.data().employeePhone;

          const aboutMe = doc.data().aboutMe;
          const userWebsite = doc.data().userWebsite;



          const whyInterested = doc.data().whyInterested;
          const course = doc.data().course;
          const sessionTime = doc.data().sessionTime;
          const classType = doc.data().classType;

          const profilePic = doc.data().profilePic;
          const coverPhoto = doc.data().coverPhoto;  


          setLoggedInUser(username);
          setEmployeeId(employeeId);
          setEmployeePosition(employeePosition);
          setEmployeeDepartment(employeeDepartment);
          setNationality(nationality);
          setUserEmail(userEmail);
          setUserPhone(phoneNumber);
          setUserWebsite(userWebsite);
          setUserAbout(aboutMe);
          setUserExpectation(whyInterested);

          setUserCourse(course);
          setUserSessionTime(sessionTime);
          setUserClassType(classType);

          //pictures

          let myxx = profilePic + "1";
          let myYY = coverPhoto + "1";


          if(myxx === "undefined1"){
            setProfilePicture(profilePictureContImage);         
          }else{
            setProfilePicture(profilePic);
          }

          //
          if(myYY === "undefined1"){
            setCoverPicture(coverPhotoContImage);
          }else{
            setCoverPicture(coverPhoto);
          }

          })
          setIsLoading(false);
      })

      } else {
      // User is signed out
        setIsLoading(false);
      }
    });

    return () => unsubscribe();
  }, [auth]);


  //go to edit profile page
  let navigate = useNavigate();
  function goToEdtAccount(){
    navigate("/edit-profile")
  }




  return (
    <div>
       <div className='profileComp'>
            {isLoading ? (
              <div className='profileSkeleton'>
                <div className='profileSkeletonHero'>
                  <div className='profileSkeletonCover' />
                  <div className='profileSkeletonContent'>
                    <div className='profileSkeletonAvatar' />
                    <div className='profileSkeletonText'>
                      <div className='skeleton-line skeleton-line--title' />
                      <div className='skeleton-line' />
                      <div className='profileSkeletonTags'>
                        <div className='skeleton-pill' />
                        <div className='skeleton-pill' />
                        <div className='skeleton-pill' />
                      </div>
                    </div>
                    <div className='skeleton-button' />
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className='profileHero'>
                    <div className='profileHeroCover'>
                      <img src={userCoverPicture} alt="" />
                      <div className='profileHeroOverlay'></div>
                    </div>

                    <div className='profileHeroContent'>
                      <div className='profileAvatar'>
                        <img src={userProfilePicture} alt="" />
                      </div>

                      <div className='profileHeroText'>
                        <h3>{loggedInUser || "Instructor"}</h3>
                        <p><FontAwesomeIcon icon={faMapMarkerAlt} className="profileLocationIcon"/> {userNationality || "Location not set"}</p>
                        <div className='profileHeroTags'>
                          <span>{employeePosition || "Instructor"}</span>
                          <span>{employeeDepartment || "Academic team"}</span>
                          <span>{userCourse || "Course not set"}</span>
                        </div>
                      </div>

                      <button onClick={goToEdtAccount} className="profileEditButton">Edit Profile</button>
                    </div>
                </div>

                <div className='profileGrid'>
                  <div className='profileCard'>
                    <div className='profileCardHeader'>
                      <h6><FontAwesomeIcon icon={faInfoCircle} className=""/> About</h6>
                    </div>
                    <p className='profileCardText'>{userAbout || "Tell students a little about your teaching style and background."}</p>

                    <div className='profileDivider'></div>

                    <h6 className='profileSectionTitle'>Teaching focus</h6>
                    <p className='profileCardText'>{userExpectation || "Share what students can expect from your classes."}</p>
                  </div>

                  <div className='profileCard'>
                    <div className='profileCardHeader'>
                      <h6>Contact</h6>
                    </div>

                    <div className='profileContactItem'>
                      <FontAwesomeIcon icon={faEnvelope} />
                      <div>
                        <span>Email</span>
                        <p>{userEmail || "Not provided"}</p>
                      </div>
                    </div>

                    <div className='profileContactItem'>
                      <FontAwesomeIcon icon={faPhone} />
                      <div>
                        <span>Phone</span>
                        <p>{userPhone || "Not provided"}</p>
                      </div>
                    </div>

                    <div className='profileContactItem'>
                      <FontAwesomeIcon icon={faGlobe} />
                      <div>
                        <span>Website</span>
                        {userWebsite ? (
                          <a href={userWebsite} target="_blank" rel="noreferrer">{userWebsite}</a>
                        ) : (
                          <p>Not provided</p>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className='profileCard profileCardWide'>
                    <div className='profileCardHeader'>
                      <h6><FontAwesomeIcon icon={faBriefcase} /> Instructor Details</h6>
                      <p className='profileCardText'>Your teaching identity and academic placement inside Ubunifu Smart Campus.</p>
                    </div>

                    <div className='profileKeyGrid'>
                      <div className='profileKeyItem'>
                        <span>Employee ID</span>
                        <p>{employeeId || "Not provided"}</p>
                      </div>
                      <div className='profileKeyItem'>
                        <span>Position</span>
                        <p>{employeePosition || "Instructor"}</p>
                      </div>
                      <div className='profileKeyItem'>
                        <span>Department</span>
                        <p>{employeeDepartment || "Academic team"}</p>
                      </div>
                      <div className='profileKeyItem'>
                        <span>Course</span>
                        <p>{userCourse || "Not assigned"}</p>
                      </div>
                      <div className='profileKeyItem'>
                        <span>Class type</span>
                        <p>{userClassType || "Not set"}</p>
                      </div>
                      <div className='profileKeyItem'>
                        <span>Session time</span>
                        <p>{userSessionTime || "Not set"}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
        </div>
    </div>
  )
}

export default ProfileComp
